/*
 * Copyright (c) Dito Technologies
 */

import React from "react";
import {State, StepStatus, StepType} from "ui/feature/root/FormReducer";
import {Props as StepperItemProps} from "ui/kit/stepper/StepperItem"
import {IconDefinition} from "@fortawesome/fontawesome-svg-core";
import {faCheck, faPencil, faRotate, faXmark} from "@fortawesome/free-solid-svg-icons";

function stepperStateForStatus(icon: StepStatus): "error" | "warning" | "success" {
    switch (icon) {
        case StepStatus.NEEDS_EDIT:
            return "warning";
        case StepStatus.ERROR:
            return "error";
        case StepStatus.SUCCESS:
            return "success";
        case StepStatus.IN_PROGRESS:
            return "warning";
    }
}

function iconForStatus(icon: StepStatus): IconDefinition {
    switch (icon) {
        case StepStatus.ERROR:
            return faXmark;
        case StepStatus.IN_PROGRESS:
            return faRotate;
        case StepStatus.SUCCESS:
            return faCheck
        case StepStatus.NEEDS_EDIT:
            return faPencil;
        default:
            throw new Error("unknown icon")
    }
}

export default function UseRootStepper(state: State): StepperItemProps[] {

    const uploadStep: StepperItemProps = React.useMemo(() => {
        return {
            title: "Upload Sheet Music",
            description: "Upload each page for this particular piece",
            icon: iconForStatus(state.uploadStepStatus),
            state: stepperStateForStatus(state.uploadStepStatus),
            selected: state.selectedStep === StepType.UPLOAD
        }
    }, [state.uploadStepStatus, state.selectedStep])

    const selectStaffsStep: StepperItemProps = React.useMemo(() => {
        return {
            title: "Select Staffs",
            description: "Ensure that we found all of the right staffs in your piece",
            icon: iconForStatus(state.staffSelectStepStatus),
            state: stepperStateForStatus(state.staffSelectStepStatus),
            selected: state.selectedStep === StepType.STAFF_SELECT
        }
    }, [state.staffSelectStepStatus, state.selectedStep]);

    const verifyNotesStep: StepperItemProps = React.useMemo(() => {
        return {
            title: "Verify Notes",
            description: "Verify that all of the notes that we found were correct",
            icon: iconForStatus(state.noteFinderUserConfirmationStatus),
            state: stepperStateForStatus(state.noteFinderUserConfirmationStatus),
            selected: state.selectedStep === StepType.VERIFY_NOTES
        }
    }, [state.noteFinderUserConfirmationStatus, state.selectedStep])

    const downloadStep: StepperItemProps = React.useMemo(() => {
        return {
            title: "Use",
            description: "Play, listen and learn your music piece",
            icon: iconForStatus(state.downloadStepStatus),
            state: stepperStateForStatus(state.downloadStepStatus),
            selected: state.selectedStep === StepType.DOWNLOAD
        }
    }, [state.downloadStepStatus, state.selectedStep])

    return [uploadStep, selectStaffsStep, verifyNotesStep, downloadStep];
}
